module.exports = __webpack_public_path__ + "static/ring_of_resistance_electricity-fbe0a48d5df5e9c2c9680257f8d73ccc.jpeg";